module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customize":"Customize Bundle","choose":"Choose","qty":"Qty."},"ar":{"customize":"تعديل العرض","choose":"اختر","qty":"الكمية"}}')
  delete Component.options._Ctor
}
